import {
  type Branding,
  ChatAvailability,
  ClientName,
  type ContactSupportConfig,
  FlightShopDefaultSort,
  I18nNamespace,
} from "@hopper-b2b/types";
import { DateTimeFormatStyle, formatDateTime } from "@hopper-i18n/formatter";

const contactSupport: ContactSupportConfig = {
  chatAvailability: ChatAvailability.None,
  displaySupportNumber: "+5540200185",
  supportNumber: "40200185",
  intlSupportNumber: "551120390650",
};

// Keep these languages in sync with what are in vite.config.ts
// TODO use env or something to define these at one place
const supportedLanguages = [
  { key: "pt", name: "Portuguese", label: "Portuguese" },
  { key: "en", name: "English", label: "English" },
];
export const branding: Branding = {
  default: "pt",
  contactSupport,
  merchantPayments: "",
  clientName: ClientName.NUBANK,
  currencies: [
    {
      locale: "pt-BR",
      code: "BRL",
      symbol: "R$",
      highInflationCurrency: true,
    },
  ],
  supportedLanguages,
  adaChat: {
    answerIds: {
      delayOrMissedConnection: "6418b6f2d98bdd47409e0705",
    },
  },
  lodgingCardPriceRounding: 2,
  flightShopDefaultSort: FlightShopDefaultSort.TagsThenPrice,
  hideWatchesInTrips: true,
  [I18nNamespace.translation]: {
    pt: {
      portalName: "Nubank com Hopper",
      urls: {
        termsAndConditions: "",
        privacyPolicy: "",
        htsAddOns: "https://hts.hopper.com/legal/pt-br-what-are-hts-add-ons",
        benefitsFromAirline:
          "https://hts.hopper.com/legal/pt-br-hts-passenger-rights-overview",
        disruptionTerms:
          "https://hts.hopper.com/legal/nuviagens-remarcacao-garantida",
        cfarTerms:
          "https://hts.hopper.com/legal/nuviagens-cancelamento-flexivel",
      },
      preferredCountryCode: "BR",
      preferredAreaCode: "+55",
      calendarMonthFormat: "MMMM YYYY",
      calendarDateLabelFormat: "DD MMM YY",
      timeFormat: "HH:mm",
      customDateTimeFormats: {
        tripsList: (date: Date) => {
          const formattedDate = formatDateTime(
            date,
            "pt-BR",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          );
          return formattedDate.replace(/(de|\.)+/g, "");
        },
        hotelSummary: (date: Date) =>
          formatDateTime(date, "pt-BR", DateTimeFormatStyle.FullDate),
        calendar: (date: Date) => {
          const formattedDate = formatDateTime(
            date,
            "pt-BR",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          );
          return formattedDate.replace(/(de |\.)+/g, "");
        },
        shopEditButton: (date: Date) => {
          const formattedDate = formatDateTime(
            date,
            "pt-BR",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          );
          return formattedDate.replace(/(de|\.)+/g, "");
        },
        fareDetails: (date: Date) => {
          const formattedDate = formatDateTime(
            date,
            "pt-BR",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          );
          return formattedDate.replace(/(de|\.)+/g, "");
        },
        watchList: (date: Date) => {
          const formattedDate = formatDateTime(
            date,
            "pt-BR",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
            })
          );
          return formattedDate.replace(/(de|\.)+/g, "");
        },
      },
    },
    en: {
      portalName: "Nubank with Hopper",
      urls: {
        termsAndConditions: "",
        privacyPolicy: "",
        htsAddOns: "https://hts.hopper.com/legal/pt-br-what-are-hts-add-ons",
        benefitsFromAirline:
          "https://hts.hopper.com/legal/pt-br-hts-passenger-rights-overview",
        disruptionTerms:
          "https://hts.hopper.com/legal/nuviagens-remarcacao-garantida",
        chat: "nuapp://nuchat",
        cfarTerms:
          "https://hts.hopper.com/legal/nuviagens-cancelamento-flexivel",
      },
      preferredCountryCode: "BR",
      preferredAreaCode: "+55",
      calendarMonthFormat: "MMMM YYYY",
      timeFormat: "HH:mm",
      customDateTimeFormats: {
        tripsList: (date: Date) =>
          formatDateTime(
            date,
            "en",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          ),
        hotelSummary: (date: Date) =>
          formatDateTime(date, "en", DateTimeFormatStyle.FullDate),
        calendar: (date: Date) =>
          formatDateTime(
            date,
            "en",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          ),
        shopEditButton: (date: Date) =>
          formatDateTime(
            date,
            "en",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          ),
        fareDetails: (date: Date) =>
          formatDateTime(
            date,
            "en",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
              year: "2-digit",
            })
          ),
        watchList: (date: Date) =>
          formatDateTime(
            date,
            "en",
            DateTimeFormatStyle.Custom({
              day: "2-digit",
              month: "short",
            })
          ),
      },
    },
  },
};
